/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { EMode } from 'common/const/common.enum';

export interface IWorkspaceContext {
  openPositionCard: boolean;
  setOpenPositionCard: (value: boolean) => void;
  openEditPositionCard: boolean;
  setOpenEditPositionCard: (value: boolean) => void;
  editPositionCardMode: EMode;
  setEditPositionCardMode: (value: EMode) => void;
}

export const WorkspaceContext = createContext<IWorkspaceContext>({
  openPositionCard: false,
  setOpenPositionCard: () => {},
  openEditPositionCard: false,
  setOpenEditPositionCard: () => {},
  editPositionCardMode: EMode.Edit,
  setEditPositionCardMode: () => {},
});
